import axiosInstance from "./axiosInstance";
import axiosInstanceMicrosite from "./axiosInstanceMicrosite";

export default class EntitySectionsApi {
  /**
   * List all entity sections
   * @returns {Promise} - Promise with entity sections data
   */
  static list(limit, offset) {
    return axiosInstance.get("/entity_sections", {
      params: { limit, offset },
    });
  }

  /**
   * Create a new entity section
   * @param {Object} entitySection - Entity section data
   * @returns {Promise} - Promise with created entity section data
   */
  static create(entitySection) {
    return axiosInstance.post("/entity_sections", entitySection);
  }

  /**
   * Update an existing entity section
   * @param {Object} entitySection - Entity section data
   * @returns {Promise} - Promise with updated entity section data
   */
  static update(id, entitySection) {
    return axiosInstance.put(`/entity_sections/${id}`, entitySection);
  }

  /**
   * Delete an existing entity section
   * @param {string} id - Entity section ID
   * @returns {Promise} - Promise with deleted entity section data
   */
  static delete(id) {
    return axiosInstance.delete(`/entity_sections/${id}`);
  }

  /**
   * Clone an existing entity section
   * @param {string} id - Entity section ID
   * @returns {Promise} - Promise with cloned entity section data
   */
  static clone(id) {
    return axiosInstance.post(`/entity_sections/${id}/clone`);
  }

  /**
   * Get a single entity section by ID
   * @param {string} id - Entity section ID
   * @returns {Promise} - Promise with entity section data
   */
  static show(id) {
    return axiosInstance.get(`/entity_sections/${id}`);
  }

  /**
   * Get a single entity section by ID for a microsite
   * @param {string} id - Entity section ID
   * @returns {Promise} - Promise with entity section data
   */
  static showForMicrosite(id) {
    return axiosInstanceMicrosite
      .get(`/sections/${id}`)
      .then((response) => response.data);
  }
}
